import LogoEmpresa from '../assets/LogoEmpresa.png'
import { Link } from "react-router-dom";
import NetworkGraph from "./NetworkGraph";

export default function Footer() {
  return (
    <footer className="footer">
      <NetworkGraph variant="footer" />
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/">
              <img
                src={LogoEmpresa}
                alt="logo sepolTECH"
                className="logo"
              />
            </Link>
            <p>
              Conectando Soluções, Impulsionando o Futuro.
              <br />
              <br />
              MSP em São Paulo desde 2007.
            </p>
          </div>

          <div className="footer__col">
            <h4>Serviços</h4>
            <Link to="/servicos/gestao-ti">Gestão de TI (MSP)</Link>
            <Link to="/servicos/rmm">RMM / Endpoints</Link>
            <Link to="/servicos/suporte">Suporte Técnico</Link>
            <Link to="/servicos/acesso-remoto">Acesso Remoto</Link>
            <Link to="/servicos/consultoria">Consultoria</Link>
            <Link to="/portfolio">Desenvolvimento de sites</Link>
          </div>

          <div className="footer__col">
            <h4>Produtos</h4>
            <Link to="https://sepolhost.com.br/" target="_blank">sepolHOSTING</Link>
            <Link to="/produtos/sepol-drive">sepolDRIVE</Link>
            <Link to="/produtos/sepol-backup">sepolBACKUP</Link>
            <Link to="/produtos/sepol-chat">sepolCHAT</Link>
            <Link to="/produtos/sepol-security">sepolSECURITY</Link>
            <Link to="/produtos/erp">ERP Bruning</Link>
            <Link to="/produtos/outsourcing-locacao">Outsourcing &amp; Locação</Link>
          </div>

          <div className="footer__col">
            <h4>Empresa</h4>
            <Link to="/sobre">Sobre nós</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/base-conhecimento">Base de Conhecimento</Link>
            <Link to="/contato">Contato</Link>
            <Link to="/area-cliente">Acesso Cliente</Link>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© 2026 sepolTECH. Todos os direitos reservados.</span>
          <span>
            São Paulo, SP ·{" "}
            <a href="mailto:contato@sepoltech.com.br">
              contato@sepoltech.com.br
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
